@import "../covet-pics-gallery-item-detail/covet-pics-gallery-item-mixins.scss";

$black:  #000000;
$black2: #151515;
$white:  #FFFFFF;
$gray:   rgba($black, 0.1);
$gray3:  rgba($white, 0.1);

covet-pics-crop-text {
  display: flex;
  flex: none;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-grow: 1;
  box-sizing: border-box;
  overflow: hidden;
  width: 100%;
  &.text-review {
    height: 100%;
    max-height: 100%;
  }
  &.collage {
    &:before {
      content: "";
      display: inline-block;
      bottom: 0;
      width: 1px;
      height: 0;
      padding-top: 100%;
      visibility: hidden;
      opacity: 0;
    }
  }

  &.basic-1 {
    position: absolute;
    left: 0;
    top: 0;
    &:after {
      content: "";
      display: block;
      position: absolute;
      width: 100%;
      height: 1px;
      left: 0;
      bottom: 0;
      background-color: $gray;
    }
    @include size-xs { 
      padding: 12px; 
    } 
    @include size-sm { 
      padding: 24px 16px; 
    }
    @include size-md { 
      padding: 32px; 
    } 
    @include size-lg { 
      padding: 64px; 
    } 
  } 

  &.basic-1.verified {
    @include size-xs { 
      padding: 35px 12px 12px 12px; 
    } 
    @include size-sm { 
      padding: 33px 16px 16px 16px; 
    } 
  }

  &.basic-2 {
    background-color: #F7F7F7;
    position: absolute;
    left: 0;
    top: 0;
    @include size-xs { 
      padding: 12px; 
    } 
    &.size-xs.verified { 
      padding: 35px 12px 12px 12px; 
    } 
    @include size-sm { 
      padding: 24px 16px; 
    } 
    &.size-sm.verified { 
      padding: 33px 16px 16px 16px; 
    }
    @include size-md { 
      padding: 32px; 
    } 
    @include size-lg { 
      padding: 64px; 
    }
  }
  &.basic-2.verified {
    @include size-xs { 
      padding: 35px 12px 12px 12px; 
    } 
    @include size-sm { 
      padding: 33px 16px 16px 16px; 
    }
  }

  &.basic-3 {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #F7F7F7;
    @include size-xs { 
      padding: 12px; 
    } 
    @include size-sm { 
      padding: 24px 16px; 
    } 
    @include size-md { 
      padding: 32px; 
    } 
    @include size-lg { 
      padding: 64px; 
    } 
  }

  &.basic-3.verified {
    @include size-xs { 
      padding: 35px 12px 12px 12px; 
    }
    @include size-sm { 
      padding: 33px 16px 16px 16px; 
    }  
  }

  &.basic-4 {
    position: absolute;
    left: 0;
    top: 0;
    &:after {
      content: "";
      display: block;
      position: absolute;
      width: 100%;
      height: 1px;
      left: 0;
      bottom: 0;
      background-color: $gray;
    }
    @include size-xs { 
      padding: 12px; 
    }
    &.size-xs.verified { 
      padding: 35px 12px 12px 12px; 
    } 
    @include size-sm { 
      padding: 24px 16px; 
    } 
    &.size-sm.verified { 
      padding: 33px 16px 16px 16px; 
    }
    @include size-md { 
      padding: 32px; 
    } 
    @include size-lg { 
      padding: 64px; 
    } 
  }

  &.basic-4.verified {
    @include size-xs { 
      padding: 35px 12px 12px 12px; 
    }
    @include size-sm { 
      padding: 33px 16px 16px 16px; 
    }
  }

  &.basic-5 {
    position: absolute;
    left: 0;
    top: 0;
    &:after {
      content: "";
      display: block;
      position: absolute;
      width: 100%;
      height: 1px;
      left: 0;
      bottom: 0;
      background-color: $black;
    }
    &.size-xs { 
      padding: 12px; 
    } 
    &.size-xs.verified { 
      padding: 35px 12px 12px 12px; 
    } 
    &.size-sm { 
      padding: 24px 16px; 
    }
    &.size-sm.verified { 
      padding: 35px 16px 16px 16px; 
    } 
    &.size-md { 
      padding: 32px; 
    }
    &.size-md.verified { 
      padding: 38px 32px 32px 32px; 
    }  
    &.size-lg { 
      padding: 64px; 
    } 
  }

  &.basic-6 {
    position: absolute;
    left: 0;
    top: 0;
    background-color: $black2;
    &:after {
      content: "";
      display: block;
      position: absolute;
      width: 100%;
      height: 1px;
      left: 0;
      bottom: 0;
      background-color: $gray3;
    }
    @include size-xs { 
      padding: 12px; 
    } 
    @include size-sm { 
      padding: 24px 16px; 
    } 
    @include size-md { 
      padding: 32px; 
    } 
    @include size-lg { 
      padding: 64px; 
    } 
  }

  &.basic-6.verified {
    @include size-xs { 
      padding: 35px 12px 12px 12px; 
    }
    @include size-sm { 
      padding: 33px 16px 16px 16px; 
    }
  } 

  .crop-text {
    position: absolute;
    box-sizing: border-box;
    margin: auto;
    text-align: center;
    width: 100%;
    color: var(--covet-crop-text-color);
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    font-size: var(--covet-crop-text-font-size);
    line-height: 1.4;
    -webkit-line-clamp: var(--covet-crop-text-max-lines);
  
    &.basic-1 {
      @include size-xs { 
        padding-left: 12px; 
        padding-right: 12px; 
      } 
      @include size-sm { 
        padding-left: 16px; 
        padding-right: 16px; 
      }
      @include size-md { 
        padding-left: 32px; 
        padding-right: 32px; 
      } 
      @include size-lg { 
        padding-left: 64px; 
        padding-right: 64px; 
      } 
    }
  
    &.basic-2 {
      @include size-xs { 
        padding-left: 12px; 
        padding-right: 12px; 
      } 
      @include size-sm { 
        padding-left: 16px; 
        padding-right: 16px; 
      } 
      @include size-md { 
        padding-left: 32px; 
        padding-right: 32px; 
      } 
      @include size-lg { 
        padding-left: 64px; 
        padding-right: 64px; 
      } 
    }
    
    &.basic-3 {
      @include size-xs { 
        padding-left: 12px; 
        padding-right: 12px; 
      } 
      @include size-sm { 
        padding-left: 16px; 
        padding-right: 16px; 
      } 
      @include size-md { 
        padding-left: 32px; 
        padding-right: 32px; 
      } 
      @include size-lg { 
        padding-left: 64px; 
        padding-right: 64px;
      } 
    }
  
    &.basic-4 {
      @include size-xs { 
        padding-left: 12px; 
        padding-right: 12px; 
      } 
      @include size-sm { 
        padding-left: 16px; 
        padding-right: 16px; 
      } 
      @include size-md { 
        padding-left: 32px; 
        padding-right: 32px; 
      } 
      @include size-lg { 
        padding-left: 64px; 
        padding-right: 64px;
      } 
    }
  
    &.basic-5 {
      @include size-xs { 
        padding-left: 12px; 
        padding-right: 12px; 
      } 
      @include size-sm { 
        padding-left: 16px; 
        padding-right: 16px; 
      } 
      @include size-md { 
        padding-left: 32px; 
        padding-right: 32px; 
      } 
      @include size-lg { 
        padding-left: 64px; 
        padding-right: 64px;
      } 
    }
  
    &.basic-6 {
      @include size-xs { 
        padding-left: 12px; 
        padding-right: 12px; 
      } 
      @include size-sm { 
        padding-left: 16px; 
        padding-right: 16px; 
      } 
      @include size-md { 
        padding-left: 32px; 
        padding-right: 32px; 
      } 
      @include size-lg { 
        padding-left: 64px; 
        padding-right: 64px;
      } 
    }
  }
}
